<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="text-xs-center">
        <img src="https://cdn.dribbble.com/users/891352/screenshots/3679482/shopping_cart.gif" alt="cart" width="350">
        <v-card-title class="headline white--text" style="position: absolute; top: 0">Order Completed</v-card-title>
        <v-card-text>Do you want to make a new order?</v-card-text>
        <v-card-actions>
          <router-link v-if="!isOrderV2" to="/transaction" exact><v-btn color="green" flat>Go to Transaction</v-btn></router-link>
          <router-link v-if="isOrderV2" to="/transaction-v2" exact><v-btn color="green" flat>Go to Transaction</v-btn></router-link>
          <v-spacer></v-spacer>
          <v-btn color="green" flat @click="close()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderPop',
  props: {
    isOrderV2: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    close () {
      this.$emit('closePop', null)
      this.dialog = false
    },
    back () {
      this.dialog = false
    }
  },
  watch: {
    dialog () {
      setTimeout(() => {
        this.dialog = false
      }, 300)
    }
  }
}
</script>

<style scoped>
.primary--text, .green--text {
  color: rgb(77, 189, 153)!important;
}

.green {
  background: rgb(77, 189, 153)!important;
}
</style>
